<template>
    <div >
        {{ formattedTime }}
    </div>
</template>


<script>
export default {
    emits: ['limitreached'],
    props: {
        elapsed: Number,
        limit: Number,
        disabled: Boolean
    },
    data() {
        return {
            seconds: this.elapsed || 0,
            interval: null,
        }
    },
    computed: {
        formattedTime() {
            return this.formatTime(this.seconds)
        }
    },
    watch: {
        elapsed(seconds) {
            this.seconds = seconds
        },
        disabled(isDisabled) {
            if(isDisabled) {
                clearInterval(this.interval)
            } else {
                this.interval = setInterval(this.tick, 1000)
            }
        }
    },
    mounted() {
        if(!this.elapsed && this.limit && this.limit > 0 && !this.disabled) {
            this.interval = setInterval(this.tick, 1000)
        }
    },
    methods: {
        formatTime(seconds) {
            if (isNaN(seconds) || seconds <= 0) {
                return '00:00'
            }

            const date = new Date(null);
            date.setSeconds(seconds);

            return `${date.getUTCMinutes().toString().padStart(2, '0')}:${date.getUTCSeconds().toString().padStart(2, '0')}`
        },
        tick() {
            this.seconds += 1
            if(this.seconds >= this.limit) {
                clearInterval(this.interval)
                this.$emit('limitreached')
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
};
</script>

<style lang='' scoped>
</style>